import PerksFAQsModule from './PerksFAQsModule';

export default PerksFAQsModule;
